import { RouteFactory } from "@app/routePaths";
import logoBTSG60 from "@assets/logo-btsg60.png";
import { KeywordButtonType } from "@components/Button/utils/types";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import { useBreadCrumbState } from "@components/Header/helpers";
import KeywordFilter from "@features/mybt/components/KeywordFilter";
import { KeywordType } from "@features/mybt/components/KeywordFilter/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";
import Highlights from "@routes/BTSG60/components/Highlights/Highlights";
import MoreStories from "@routes/BTSG60/components/MoreStories/MoreStories";
import Podcasts from "@routes/BTSG60/components/Podcasts/Podcasts";
import { BTSG60PageData } from "@routes/BTSG60/utils/types";
import { sectionNavigationItems } from "@util/constant";

/** The BT SG60 template page. */
const BTSG60PageContent = ({
  entity: { tag },
  highlightArticles,
  pdfDownload,
  podcastArticles,
  moreStories,
  gaProps,
}: BTSG60PageData & { gaProps: GADataProps }): React.ReactElement => {
  const { breadcrumbsRef, isShowBreadCrumb } = useBreadCrumbState();

  useInjectClientData({ gaProps });

  return (
    <div data-testid="bt-sg-60-page-content" className="w-full">
      <Header
        displayBreadcrumb={isShowBreadCrumb}
        parentCategory={RouteFactory.btsg60.replace("/", "")}
        categoryDataMapping={sectionNavigationItems}
        enableTopStoriesLink={false}
        isShownMasthead
      />

      <Container rootClassName="py-8">
        <div
          ref={breadcrumbsRef}
          className="mb-7 flex items-center border-b border-gray-850 py-3"
        >
          <div>
            <img
              src={logoBTSG60}
              width={360}
              height={54}
              alt=""
              className="w-40"
            />
          </div>

          <KeywordFilter
            keywordButtonType={KeywordButtonType.version2}
            tag={tag}
            className="inline-block w-full"
            tagClassName="border-none !font-playfair !text-6xl md:!text-8xl !p-0 text-gray-850 !uppercase !text-left !text-normal"
            disableTooltip
            keywordType={KeywordType.noTag}
            buttonClassName={"lg:ml-4"}
            isLinkenabled={false}
          />
        </div>

        <Highlights
          cardProps={highlightArticles}
          pdfDownload={pdfDownload}
          className="mb-8"
        />

        <Podcasts cardProps={podcastArticles} className="mb-8" />

        <MoreStories cardProps={moreStories} urlPath={tag.urlPath} />
      </Container>
    </div>
  );
};

export default BTSG60PageContent;
